import React, {useState, useContext, useEffect} from 'react'
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';

import DateFormated from '../Utils/Date/Date';
import Auxiliary from "../../hoc/Auxiliary";
import Currency from "../Utils/Number/Currency";
import PaymentPopup from "../UI/PaymentPopup";
import Alert from "../UI/Alerts/Alert";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

import UserContext from '../../context/user-context';
import {userHaveSpecificPermission} from "../../components/Utils/UserHelper";

import CardCarProducts from "./CardCarProducts";
import PermissionCarProducts from "./Modals/PermissionCarProducts";
import NewCard from "./Modals/NewCard";
import ModalMxo from "../UI/Modal";
import {fireGTMDownloadFileEvent} from "../Utils/GTM/GTMHelper";
import ModalConsumptionReport from "../Consumption/ModalConsumptionReport";



const cardSummary = (props) => {
    const {t, i18n} = useTranslation();
    const { user } = useContext(UserContext);

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState(null);
    const [isModalCentered, setIsModalCentered] = useState(false);
    const [isCarProductsModal, setIsCarProductsModal] = useState(true);
    const [isProductsModalCanceled, setIsCarProductsModalCanceled] = useState(false);
    const [isProductsModalSuccess, setIsProductsModalSuccess] = useState(0);

    const subaccount = props.subaccount;
    let type = subaccount.subAccountDisplayMode.code;
    let cardSummary = "";
    let dataToTest = "";

    if (!userHaveSpecificPermission(user, 'financial_data')){
        dataToTest = 0
    }
    else {
        if (type === "L" || type === "S" || type === "A") {
            dataToTest = subaccount.totalBalance.value;
        } else {
            dataToTest = subaccount.lastStatementBalance.value;
        }
    }

    const toggleCarProductsModalHandler = (checked) => {
        setIsCarProductsModal(true);
		setIsModalCentered(false);
		setIsCarProductsModalCanceled(false)
        setShowModal(true);

        setModalTitle(t('account.cards.permission_car_products.title'));
        setModalContent(<PermissionCarProducts
            closeModal={handleCloseModal}
            closeModalSuccess={handleCloseModalSuccess}
            subAccount={subaccount}
            checked={checked}/>
        );
    }

    const addCardModalHandler = () => {
        setIsCarProductsModal(false);
		setIsModalCentered(false);
		setShowModal(true);
        setShowModal(true);

        setModalTitle(t('account.cards.management.new_card.modal_title'));
        setModalContent(<NewCard
            subAccount={subaccount}
            closeModal={handleCloseModal}
			newCardSuccessModal={newCardSuccessModalHandler}
			changeModalTitle={setModalTitle}/>
        );
    }

	const localisateurLinkModal = () => {
		const linkLocalisateur = t(`account.cards.management.localisateur.link.${subaccount.seviceCode}`);
		setIsCarProductsModal(false);
		setIsModalCentered(false);
		setShowModal(true);

		setModalTitle(t("account.summary.statement.localisateur_btn"));
		setModalContent(
			<div>
				<div className="message message--info">
					<div className="message__icon">
						<i className="fas fa-exclamation-circle"></i>
					</div>
					<div className="message__content">
						<div>
							{t('account.cards.management.localisateur.localisateur_modal_notice')}
						</div>
					</div>
				</div>
				<div className="display-changer flex-wrap flex--justify-end headline--margin--10 transactions-actions">
					<button className="btn btn--outline btn--outline--gray action" onClick={handleCloseModal}>
					<span className="btn__text">
						{t('account.cards.management.buttons.cancel')}
					</span>
					</button>
					<button className="btn btn--raised btn--raised--red action" onClick={() => handleLinkInModal(linkLocalisateur)}>
						<span className="btn__text">
							<i className="fas fa-external-link-alt"></i>&nbsp;&nbsp;
							{t('account.cards.management.localisateur.localisateur_modal_continue')}
						</span>
					</button>
				</div>
			</div>
		);
	}

	const newCardSuccessModalHandler = () => {
		setModalTitle(t('account.cards.management.new_card_success.modal_title'));
		props.reloadCardSummary();

		setIsModalCentered(true);
		setModalContent(
			<div>
				<h4 className="headline headline--section">
					{ t('account.cards.management.new_card_success.modal_text') }
				</h4>
				<div className="message message--info">
					<div className="message__icon">
						<i className="fas fa-clock"></i>
					</div>
					<div className="message__content">
						<div>
							{t('account.cards.management.7days_notice')}
						</div>
					</div>
				</div>
			</div>
		);
	}

	const setModalForConsumptionReport = () => {
		setIsModalCentered(false);
		setShowModal(true);
		setModalTitle(t('account.cards.consumption_report.title'));
		setModalContent(<ModalConsumptionReport subAccount={subaccount} closeModal={handleCloseModal}/>);
	}

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setModalContent(false);

        if (isCarProductsModal)
            setIsCarProductsModalCanceled(true);
    }

	const handleLinkInModal = (url) => {
		setShowModal(false);
		setModalContent(false);
		window.open(url, "_blank");
	}

    const handleCloseModalSuccess = () => {
        setShowModal(false);
        setModalContent(false);
		setIsProductsModalSuccess(isProductsModalSuccess+1)
    }

    // Bouton de rapport de consommation
    const renderConsumptionReportButton = (className = "") => {
        if (!userHaveSpecificPermission(user, 'financial_data')) {
            return null;
        }

        return (
            <div className={className}>
                <a onClick={(e) => {
                    e.preventDefault();
                    setModalForConsumptionReport();
                }} className="link link--fs-14 link--accent link--red link--upper" target="_self">
                    <strong>
                        {t("account.summary.statement.consommationreport")}&nbsp;&nbsp;<i
                        className="fas fa-angle-right"></i>
                    </strong>
                </a>
            </div>
        );
    };

    if (type === "L" || type === "S") {

        cardSummary = (
            <div className='cardsummary cardsummary--tank'>
                <div className="container container--larger flex nopadding">
                    <div className='cardsummary__content flex flex--wrap flex--justify-space-evenly'>
                        <div className="cardsummary__content__box">
                            <h2 className="headline headline--section headline--margin--20">{t("account.summary.details.title")}</h2>
                            <div className="row">
                                <div className="col-12">
                                    <strong>
                                        {(subaccount.address.addressLine1) &&
                                        <span>{subaccount.address.addressLine1}<br/></span>}
                                        {(subaccount.address.addressLine2) &&
                                        <span>{subaccount.address.addressLine2}<br/></span>}
                                        {(subaccount.address.city) && <span>{subaccount.address.city}, {subaccount.address.stateOrProvinceCode}<br/></span>}
                                        {subaccount.address.postalCode}
                                    </strong>
                                    {subaccount.subAccountCode &&
                                    <div style={{padding: '20px 0'}}><strong>#{subaccount.subAccountCode}</strong>
                                    </div>}
                                </div>

                                <br/>
                                {subaccount.isDeliveryInProcess ?
                                    <a className="message message--success message--condensed"
                                       onClick={(e) => {
                                           e.preventDefault();
                                           props.refreshTabs('deliveries');
                                           props.changeDateFilter('current_orders');

                                       }}>
                                        <div className="message__icon">
                                            <i className="fas fa-shipping-fast"></i>
                                        </div>
                                        <div className="message__content">{t("orders.current_order")}</div>
                                        <div className="message__actions">
                                            <div className="message__action action--arrow">
                                                <i className="message__action__icon fas fa-angle-right"
                                                   aria-hidden="true"></i>
                                            </div>
                                        </div>

                                    </a> : ''
                                }
                            </div>

                            {/* Disabled for Phase 1
                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <a href="" target="_blank" className="link link--fs-14 link--accent link--red link--upper">
                                            <strong>
                                                {t("account.summary.details.pricing_comm_btn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                                            </strong>
                                        </a>
                                    </div>
                                    <br/>
                                    <div>
                                        <a href="" target="_blank" className="btn btn--outline btn--upper btn--larger">
                                            <strong>
                                                {t("account.summary.details.ask_refill_btn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                                            </strong>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            */}
                        </div>
                        <div className="cardsummary__content__box">
                            <h2 className="headline headline--section headline--margin--20">
                                {t("account.summary.title")}
                            </h2>

                            {userHaveSpecificPermission(user,'financial_data') && (
                                <div className={`row`}>
                                    <div className="col-6">
                                        <p>
                                            {t("account.summary.total_balance")}<br/>
                                            <strong className="price">
                                                <Currency value={subaccount.totalBalance.value}/>
                                            </strong>
                                        </p>
                                    </div>
                                    {
                                        (dataToTest !== '' && subaccount.isOnlinePaymentAllowed &&
                                            (dataToTest > subaccount.minimumOnlinePaymentCreditCard
                                                ||  dataToTest > subaccount.minimumOnlinePaymentEFT)  &&
                                            (dataToTest < subaccount.maximumOnlinePaymentCreditCard
                                                ||  dataToTest < subaccount.maximumOnlinePaymentEFT)) ?
                                            <div className="col-6 d-flex align-items-end">
                                                <div className="p">
                                                    <Link
                                                        className='btn btn--outline btn--outline--black btn--payment'
                                                        to={{pathname:'/payment',
                                                            state: {by: "subaccount", selection : [subaccount.subAccountCode]}
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                    </Link>
                                                </div>
                                            </div> : ''
                                    }
                                </div>
                            )}

                            <div className="row">
                                <div className="col-6 col-sm-12 col-md-6">
									{ subaccount.nextPreauthorizePaymentDate &&
										<p>
											{t("account.summary.deadline")}<br/>
											<strong>
												{subaccount.nextPreauthorizePaymentDate ? (
													<DateFormated date={subaccount.nextPreauthorizePaymentDate}/>) : ''}
											</strong>
										</p>
									}
                                    {
                                        (i18n.language === "fr" && subaccount.creditTerm.descriptionFr !== ""
                                            ? <p>Terme&nbsp;:&nbsp;<strong
                                                className="d-inline-block mt-1">{subaccount.creditTerm.descriptionFr}</strong>
                                            </p>
                                            : <p>Term:&nbsp;<strong
                                                className="d-inline-block mt-1">{subaccount.creditTerm.descriptionEn}</strong>
                                            </p>)
                                    }
                                </div>

                                {userHaveSpecificPermission(user,'financial_data') && (
                                    <div className="col-6 col-sm-12 col-md-6">
                                    <p>
                                        {t("account.summary.deadline_amount")}<br/>
                                        <strong>
                                            <Currency value={subaccount.nextPreauthorizePaymentAmount.value}/>
                                        </strong>
                                    </p>
                                </div>
                                )}
                            </div>
                            {userHaveSpecificPermission(user, 'financial_data') && subaccount.lastStatementDocumentPath && (
                                <div>
                                    <a href={`/rest/v1/communications/download?filename=${encodeURI(subaccount.lastStatementDocumentPath)}`}
                                       target="_blank" className="link link--fs-14 link--accent link--red link--upper"
										onClick={()=>fireGTMDownloadFileEvent('releve', 'PDF')}>
                                        <strong>
                                            {t("account.summary.view_statement_btn")}&nbsp;&nbsp;<i
                                            className="fas fa-angle-right"></i>
                                        </strong>
                                    </a>
                                </div>
                            )}
                            {userHaveSpecificPermission(user, 'financial_data') && (
                                <div>
                                    <a href=""
                                       onClick={(e) => {
                                           e.preventDefault();
                                           props.refreshTabs('statements');
                                           // props.setFilter('type','R');
                                       }}
                                       target="_self"
                                       className="link link--fs-14 link--accent link--red link--upper">
                                        <strong>
                                            {t("account.summary.statement_history_btn")}&nbsp;&nbsp;<i
                                            className="fas fa-angle-right"></i>
                                        </strong>
                                    </a>
                                </div>
                            )}
                            {renderConsumptionReportButton()}
                        </div>
                    </div>

                </div>
            </div>
        )
    } else if (type === "A") {
        cardSummary = (
            <>
                <div className="cardsummary__status mt-5">
                    <Alert type="success" item={{
                        type: 'success',
                        additionalClasses: 'message message--cardsummary',
                        customIcon: 'far fa-info-circle',
                        text: t('account_ajustement.tooltip')
                    }}/>
                </div>
                <div className='cardsummary cardsummary--adjustement'>
                    <div className="container container--larger flex nopadding">
                        <div className='cardsummary__content flex flex--wrap flex--justify-space-evenly'>
                            <div className="cardsummary__content__box">
                                <h2 className="headline headline--section headline--margin--20">{t("account.summary.details.title")}</h2>
                                <div className="row">
                                    <div className="col-12">
                                        <strong>
                                            {(subaccount.address.addressLine1) &&
                                            <span>{subaccount.address.addressLine1}<br/></span>}
                                            {(subaccount.address.addressLine2) &&
                                            <span>{subaccount.address.addressLine2}<br/></span>}
                                            {(subaccount.address.city) && <span>{subaccount.address.city}, {subaccount.address.stateOrProvinceCode}<br/></span>}
                                            {subaccount.address.postalCode}
                                        </strong>
                                        {subaccount.subAccountCode &&
                                        <div style={{padding: '20px 0'}}>
                                            <span>{t("account.summary.details.number")}</span><br/><strong>#{subaccount.subAccountCode}</strong>
                                        </div>}
                                    </div>
                                </div>
                            </div>

                                <div className="cardsummary__content__box">
                                <h2 className="headline headline--section headline--margin--20">
                                    {t("account.summary.title")}
                                </h2>
                                <div className="row row--addline">
                                    <div className="col-6">
                                        <p>
                                            {t("account.summary.total_balance")}<br/>
                                            <strong className="price">
                                                <Currency value={subaccount.totalBalance.value}/>
                                            </strong>
                                            <br/>
                                        </p>
                                    </div>
                                    {
                                        (dataToTest != '' && subaccount.isOnlinePaymentAllowed &&
                                        (dataToTest > subaccount.minimumOnlinePaymentCreditCard
                                            ||  dataToTest > subaccount.minimumOnlinePaymentEFT)
                                            && (dataToTest < subaccount.maximumOnlinePaymentCreditCard
                                                ||  dataToTest < subaccount.maximumOnlinePaymentEFT)
                                        ) ?
                                            <div className="col-6 d-flex align-items-end">
                                                <p>
                                                    <Link
                                                        className='btn btn--outline btn--outline--black btn--payment'
                                                        to={{pathname:'/payment',
                                                            state: {by: "subaccount", selection : [subaccount.subAccountCode]}
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                    </Link>
                                                </p>
                                            </div> : ''
                                    }

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>

        )
    } else {

        cardSummary = (
            <div className='cardsummary'>
                <div className="container container--larger flex nopadding">
                    <div className='cardsummary__infos'>
                        <strong>{t("account.cards.representative_label")}</strong><br/>
                        {subaccount.representative && <strong>{subaccount.representative}</strong>}<br/><br/>
                        {subaccount.subAccountCode && <strong>#{subaccount.subAccountCode}</strong>}
                        <p>{t('account.summary.details.cards_amount')}&nbsp;:&nbsp;{subaccount.numberOfCards}</p>
                        <strong>{t('account.summary.details.updated')}</strong>
                        <p>
                            {subaccount.lastUpdate ? (
                                <DateFormated date={subaccount.lastUpdate} withTime={true}/>) : ''}
                        </p>
                        {(Boolean(AUTOMOBILE_PRODUCTS) && subaccount.isSelfServiceSubAccountAllowed) &&
							<CardCarProducts
								subaccount={subaccount}
							 	toggleCarProductsChangeHandler={toggleCarProductsModalHandler}
								closeModal={handleCloseModal}
								isCanceled={isProductsModalCanceled}
								isProductsModalSuccess={isProductsModalSuccess}/>
						}
                    </div>
                        <div className='cardsummary__content flex flex--wrap flex--justify-space-evenly'>
                        <div className="cardsummary__content__box">
                            <h2 className="headline headline--section headline--margin--20">{t('account.summary.statement.title')}</h2>


                            <div className={`row`}>
                                {type === "K" && (
                                    <div className="col-6 col-sm-12 col-md-6">
                                        <p>
                                            {t('account.summary.statement.consumption')}<br/>
											<strong className="price">
												{
													subaccount.sinceLastStatementQuantity
													? subaccount.sinceLastStatementQuantity.value + '\u00A0' + subaccount.sinceLastStatementQuantity.unit
													: '0 L'
												}
											</strong>
										</p>
									</div>
								)}
								<div className="col-6 col-sm-12 col-md-6">
									{userHaveSpecificPermission(user,'financial_data') && (
                                        <p>
                                            {t('account.summary.statement.balance')}<br/>
                                            <strong className="price">
                                                <Currency value={subaccount.lastStatementBalance.value}/>
                                            </strong>
                                        </p>
                                    )}
                                    {
                                        (dataToTest != '' && subaccount.isOnlinePaymentAllowed &&
                                            (dataToTest > subaccount.minimumOnlinePaymentCreditCard
                                        ||  dataToTest > subaccount.minimumOnlinePaymentEFT) &&
                                            (dataToTest < subaccount.maximumOnlinePaymentCreditCard
                                                ||  dataToTest < subaccount.maximumOnlinePaymentEFT)
                                        ) ?
                                            <p>
                                                <Link
                                                    className='btn btn--outline btn--outline--black btn--payment'
                                                    to={{pathname:'/payment',
                                                        state: {by: "subaccount", selection : [subaccount.subAccountCode]}
                                                    }}
                                                >
                                                    <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('payment.button')}
                                                </Link>
                                            </p> : ''
                                    }

                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6 col-sm-12 col-md-6">
                                    <p>
                                        {t('account.summary.statement.issuing_date')}<br/>
                                        <strong>
                                            {subaccount.lastStatementDate ? (
                                                <DateFormated date={subaccount.lastStatementDate}/>) : ''}
                                        </strong>
                                    </p>
                                </div>
								{
									userHaveSpecificPermission(user, 'financial_data') &&
										<div className="col-6 col-sm-12 col-md-6">
											{subaccount.nextPreauthorizePaymentDate ?
												<p>
													{t('account.summary.statement.ppa')}<br/>
													<strong>
														{<DateFormated date={subaccount.nextPreauthorizePaymentDate}/>}
													</strong>
												</p> :
												<p>
													{t('account.summary.statement.deadline')}<br/>
													<strong>
														{subaccount.lastStatementDueDate ? (
															<DateFormated date={subaccount.lastStatementDueDate}/>) : ''}
													</strong>
												</p>
											}
										</div>
								}

                            </div>
                            <div>
                                {userHaveSpecificPermission(user, 'financial_data') && subaccount.lastStatementDocumentPath && (
                                    <div>
                                        <a href={`/rest/v1/communications/download?filename=${encodeURI(subaccount.lastStatementDocumentPath)}`}
                                           target="_blank"
										   onClick={()=>fireGTMDownloadFileEvent('releve', 'PDF')}
                                           className="link link--fs-14 link--accent link--red link--upper">
                                            <strong>{t('account.summary.statement.statement_download_btn')}&nbsp;&nbsp;
                                                <i className="fas fa-angle-right"></i></strong>
                                        </a>
                                    </div>
                                )}
                                {userHaveSpecificPermission(user, 'financial_data') && (
                                    <div>
                                        <a href="" onClick={(e) => {
                                            e.preventDefault();
                                            props.refreshTabs('statements');
                                            // props.setFilter('type','R');
                                        }}
                                           target="_self"
                                           className="link link--fs-14 link--accent link--red link--upper">
                                            <strong>{t('account.summary.statement.statement_history_btn')}&nbsp;&nbsp;<i
                                                className="fas fa-angle-right"></i></strong>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
							<div className="cardsummary__content__box">
								<h2 className="headline headline--section headline--margin--20">{t('account.summary.statement.current_period_title')}</h2>
								<div className="row">
									{type === "K" && (
										<div className="col-6 col-sm-12 col-md-6">
											<p>
												{t('account.summary.statement.consumption')}<br/>
												<strong
													className="price">{subaccount.sinceLastStatementQuantity?.value + '\u00A0' + subaccount.sinceLastStatementQuantity?.unit}</strong>
											</p>
										</div>
									)}
									<div className="col-6 col-sm-12 col-md-6">
										{userHaveSpecificPermission(user, 'financial_data') && (
											<p>
												{t('account.summary.statement.ongoing')}<br/>
												<strong className="price">
													<Currency value={subaccount.sinceLastStatementBalance.value}/>
												</strong>
											</p>
										)}
									</div>
								</div>

								{userHaveSpecificPermission(user, 'financial_data') && (
									<div>
										<a href="" onClick={(e) => {
											e.preventDefault();
											props.refreshTabs('transactions')
										}} className="link link--fs-14 link--accent link--red link--upper"
										   target="_self">
											<strong>
												{t("account.summary.statement.transactions_btn")}&nbsp;&nbsp;<i
												className="fas fa-angle-right"></i>
											</strong>
										</a>
									</div>
								)}
								{renderConsumptionReportButton()}
								{userHaveSpecificPermission(user, 'financial_data') && (
									<button
										className='btn btn--outline btn--outline--black btn--payment mt-3'
										onClick={addCardModalHandler}>
										<i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp; {t("account.summary.statement.card_btn")}
									</button>
								)}
								{(subaccount.seviceCode === "CDE" || subaccount.seviceCode === "CES") &&
									<button
										className='btn btn--outline btn--outline--black btn--payment mt-3'
										onClick={localisateurLinkModal}>
										<i className="fas fa-map-marker-alt"></i>&nbsp;&nbsp; {t("account.summary.statement.localisateur_btn")}
									</button>
								}
							</div>

						</div>
				</div>
			</div>
		)
	}

	return (
		<div>
			{cardSummary}

			<ModalMxo title={modalTitle}
					  modalClass={isModalCentered ? 'confirmation-modal' : ''}
					  show={showModal}
					  hideFooter={true}
					  footerActions={null}
					  backDrop={"static"}
					  onHide={handleCloseModal}
					  onShow={handleShowModal}>
				{modalContent}
			</ModalMxo>

		</div>
	);
};


export default cardSummary
